export default "__VITE_ASSET__33b48343__"